enum AnimationKeys {
  RocketMouseRun = 'rocket-mouse-run',
  RocketFlamesOn = 'rocket-flames-on',
  RocketMouseFall = 'rocket-mouse-fall',
  RocketMouseFly = 'rocket-mouse-fly',
  RocketMouseDead = 'rocket-mouse-dead',
  RocketMouseThrow = 'rocket-mouse-throw',
  CoinSpin = 'coin-spin',
  DroneHover = 'drone-hover',
  UKFlagWave = 'uk-flag-wave',
}

export default AnimationKeys
